import { useScopedHref } from "@/hooks";
import { useLeagueOnboarding } from "@/pages/league/LeagueOnboardingPage";
import { OnboardingBanner as LibOnboardingBanner } from "@/ui";

export type LeagueOnboardingBannerProps = {
  /** League public id (`lge_…`) the onboarding progress belongs to. */
  leagueId: string;
  className?: string;
};

/**
 * League-scoped mirror of the platform `OnboardingBanner`. Fetches the league's
 * onboarding progress directly (React Query dedupes with the overview card /
 * dedicated page), hides itself once every visible step is complete, and links
 * to the dedicated league onboarding page.
 */
export const LeagueOnboardingBanner = ({ leagueId, className }: LeagueOnboardingBannerProps) => {
  const scopedHref = useScopedHref();
  const { isPending, isError, allComplete } = useLeagueOnboarding(leagueId);

  if (!leagueId || isError) return null;
  if (!isPending && allComplete) return null;

  return (
    <LibOnboardingBanner
      href={scopedHref(`/league/${leagueId}/onboarding`)}
      isLoading={isPending}
      className={className}
    />
  );
};
